import { Layout } from '@ui-kitten/components';
import { UIHelper as uh } from '../../core';
import { StyleSheet } from 'react-native';
import React, { useState } from 'react';
import { ErrorModal } from 'src/components/shared/ErrorModal';
import Spinner from 'react-native-loading-spinner-overlay/lib';
import MarkerList from './MarkerList';
import { useLatestMarkersEffect } from 'src/core/hooks/useMyMarkers';

const styleContainer = StyleSheet.create({
  screenContainer: {
    flex: 1,
    paddingBottom: uh.h2DP(20)
  }
});

const FavoriteListContainer = () => {
  const [latestMarkersRefreshing, setLatestMarkersRefreshing] = useState<boolean>(false);
  const [latestMarkers, isLastestMarkersLoading, lastestMarkersError] = useLatestMarkersEffect({
    refreshing: latestMarkersRefreshing,
    setRefreshing: setLatestMarkersRefreshing
  });

  if (isLastestMarkersLoading) {
    return <Spinner visible={true} />;
  }

  //view
  return (
    <Layout level="2" style={styleContainer.screenContainer}>
      <MarkerList markers={latestMarkers} currentPageNumber={0} />
      <ErrorModal visible={lastestMarkersError != undefined} message={{ ...lastestMarkersError }} />
    </Layout>
  );
};

export default FavoriteListContainer;
